/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-card-content[_ngcontent-%COMP%]{padding:20px}@media (min-width:768px){.nsc-card-content[_ngcontent-%COMP%]{padding:20px 45px}.nsc-card-content--tight[_ngcontent-%COMP%]{padding:25px 35px}}"];
export { styles as styles };
